import { MemberListWrapper } from './styles';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { userBetsRecordState } from '../state';
import { useAtomValue } from 'jotai';
import { PrizeType, RewardRecord } from '../types';
import MemberItem from './MemberItem';
import DelayFadeOut from '@/components/features/casino/rush/WinningBroadcast/DelayFadeOut';
import { useUser } from '@/state/userInfo/hooks';

interface MemberRecord extends RewardRecord {
  id: string;
}

export default function BlinkingOnlinePlayers() {
  const [curList, setCurList] = useState<RewardRecord[]>([]);

  const list = useAtomValue(userBetsRecordState);
  const { isCurrentUser, name } = useUser();
  const playerRewords: MemberRecord[] = list.map((item, index) => {
    return {
      ...item,
      id: `${index}_${item.bettingAmount}_${item.rewardValue}`,
      userName: isCurrentUser(item.uid || item.userId) ? name : item.userName,
    };
  });
  //reset list
  useEffect(() => {
    setCurList([]);
  }, []);

  useEffect(() => {
    if (playerRewords.length === 0) {
      setCurList([]);
      return;
    }
    setCurList((prev) => {
      const newList = [...prev];
      const lastOne = playerRewords[playerRewords.length - 1];
      if (
        newList.length > 0 &&
        lastOne.createdTime === newList[newList.length - 1].createdTime
      ) {
        return newList;
      }
      if (newList.length >= 5) {
        newList.pop();
      }
      newList.unshift(playerRewords[playerRewords.length - 1]);
      return newList;
    });
  }, [playerRewords.length]);

  const opacityMap = [1, 1, 1, 0.8, 0.5];

  return (
    <MemberListWrapper>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          maxHeight: '240px',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          {curList.map((item, index) => {
            return (
              <DelayFadeOut key={item.createdTime}>
                <MemberItem
                  key={item.createdTime}
                  opacity={opacityMap[index]}
                  item={item}
                />
              </DelayFadeOut>
            );
          })}
        </Box>
      </Box>
    </MemberListWrapper>
  );
}
